import type { ComponentType, HTMLAttributes } from 'react';

type MacaronIconImageProps = HTMLAttributes<HTMLSpanElement>;

export type MacaronInlineIconComponent = ComponentType<MacaronIconImageProps>;
type MacaronInlineIconDefinition = { line: MacaronInlineIconComponent; filled?: MacaronInlineIconComponent };

const MACARON_ICON_ASSET_ROOT = '/assets/macaron-icons';

// These SVGs are copied directly from macaron-flutter so the web A2UI icon contract
// stays aligned with Flutter's canonical registry instead of a hand-maintained subset.
const FLUTTER_MACARON_ICON_NAMES = [
  'abdominal',
  'afferent',
  'alarm',
  'alarm-clock',
  'all-application',
  'anguished-face',
  'application-effect',
  'arrow-circle-down',
  'arrow-circle-left',
  'arrow-circle-right',
  'arrow-circle-up',
  'arrow-left',
  'arrow-right',
  'avocado-one',
  'birthday-cake',
  'book',
  'book-one',
  'book-open',
  'bowl',
  'calendar-thirty',
  'camera',
  'cheese',
  'chef-hat-one',
  'cook',
  'copy',
  'disappointed-face',
  'dislike',
  'emotion-unhappy',
  'equalizer',
  'fire',
  'goblet',
  'grinning-face-with-tightly-closed-eyes-open-mouth',
  'hamburger-button',
  'history',
  'home',
  'hourglass-null',
  'knife-fork',
  'leaves-two',
  'left-c',
  'lightning',
  'like',
  'link',
  'local-two',
  'mail-open',
  'more',
  'more-one',
  'notes',
  'phone-telephone',
  'pic-one',
  'platte',
  'pot',
  'preview-close-one',
  'preview-open',
  'protection',
  'refresh',
  'refrigerator',
  'right-c',
  'rss',
  'search',
  'setting-three',
  'share',
  'share-two',
  'shopping-bag-one',
  'sleep',
  'smiling-face-with-squinting-eyes',
  'star',
  'stopwatch',
  'success',
  'tea-drink',
  'thumbs-down',
  'thumbs-up',
  'time',
  'tips',
] as const;

function createMacaronAssetIcon(src: string): MacaronInlineIconComponent {
  return function MacaronAssetIcon({ className, style, ...props }: MacaronIconImageProps) {
    return (
      <span
        aria-hidden="true"
        {...props}
        className={className ? `block shrink-0 bg-current ${className}` : 'block shrink-0 bg-current'}
        style={{
          maskImage: `url(${src})`,
          maskRepeat: 'no-repeat',
          maskPosition: 'center',
          maskSize: 'contain',
          WebkitMaskImage: `url(${src})`,
          WebkitMaskRepeat: 'no-repeat',
          WebkitMaskPosition: 'center',
          WebkitMaskSize: 'contain',
          ...style,
        }}
      />
    );
  };
}

export const MACARON_INLINE_ICONS: Record<string, MacaronInlineIconDefinition> = Object.fromEntries(
  FLUTTER_MACARON_ICON_NAMES.map((name) => [
    name,
    {
      line: createMacaronAssetIcon(`${MACARON_ICON_ASSET_ROOT}/line/${name}.svg`),
      filled: createMacaronAssetIcon(`${MACARON_ICON_ASSET_ROOT}/filled/${name}.svg`),
    },
  ]),
) as Record<string, MacaronInlineIconDefinition>;
